<template>
  <BModal
    :modelValue="visible"
    @update:modelValue="$emit('update:visible', $event)"
    dialog-class="modal-lg"
    :title="helper.trans('fraudex.check_result')"
    body-class="pt-3"
  >
    <template #default>
      <div v-if="fraudexCheck">
        <div v-if="fraudexCheck.error" class="alert alert-danger" role="alert">
          <h6 class="alert-heading mb-2">
            <i class="fa fa-exclamation-triangle me-2"></i>
            {{ helper.trans('fraudex.check_error') }}
          </h6>
          <p class="mb-0">
            {{ fraudexCheck.error }}
          </p>
        </div>

        <div v-else>
          <div v-if="fraudexCheck.isBlacklisted === false">
            <div class="alert alert-success" role="alert">
              <h6 class="alert-heading mb-2">
                <i class="fa fa-check-circle me-2"></i>
                {{ helper.trans('fraudex.not_in_blacklist') }}
              </h6>
              <p class="mb-0 small">
                <strong>{{ helper.trans('labels.requisites') }}:</strong> {{ fraudexCheck.requisite }}
              </p>
            </div>
          </div>

          <div v-else-if="fraudexCheck.isBlacklisted === true">
            <div class="alert alert-danger" role="alert">
              <h6 class="alert-heading mb-2">
                <i class="fa fa-exclamation-triangle me-2"></i>
                {{ helper.trans('fraudex.in_blacklist') }}
              </h6>
              <p class="mb-0 small">
                <strong>{{ helper.trans('labels.requisites') }}:</strong> {{ fraudexCheck.requisite }}
              </p>
            </div>

            <div v-if="fraudexCheck.comments && fraudexCheck.comments.length > 0" class="mb-3 mt-3 fraudex-comments">
              <h6 class="fraudex-comments__title mb-3">{{ helper.trans('fraudex.comments') }}:</h6>
              <ul class="fraudex-comments__list">
                <li v-for="(comment, index) in fraudexCheck.comments" :key="index" class="fraudex-comments__item">
                  {{ comment }}
                </li>
              </ul>
            </div>

            <div class="mb-3">
              <div class="form-check">
                <input 
                  class="form-check-input" 
                  type="checkbox" 
                  v-model="riskConfirmed" 
                  id="riskConfirmation"
                >
                <label class="form-check-label" for="riskConfirmation">
                  {{ helper.trans('fraudex.confirm_risks') }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <button 
        type="button" 
        @click="$emit('cancel')" 
        class="btn btn-outline-secondary btn-sm text-capitalize-first"
      >
        {{ helper.trans('button.cancel') }}
      </button>
      <button 
        type="button" 
        @click="$emit('continue')" 
        :disabled="fraudexCheck && !fraudexCheck.error && fraudexCheck.isBlacklisted === true && !riskConfirmed"
        class="btn btn-outline-primary btn-sm text-capitalize-first"
      >
        <i class="fa fa-check me-2"></i>
        {{ helper.trans('button.continue') }}
      </button>
    </template>
  </BModal>
</template>

<script lang="ts">
import { defineComponent, ref, watch, PropType } from 'vue';
import { BModal } from 'bootstrap-vue-3';
import { helper } from '@/service/CommonHelper';
import FraudexCheckResponseDTO from '@/models/FraudexCheckResponseDTO';

export default defineComponent({
  name: 'FraudexCheckModal',
  components: {
    BModal,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    fraudexCheck: {
      type: Object as PropType<FraudexCheckResponseDTO | null>,
      default: null,
    },
  },
  emits: ['update:visible', 'continue', 'cancel'],
  setup(props) {
    const riskConfirmed = ref(false);

    watch(() => props.visible, (newVal) => {
      if (newVal) {
        riskConfirmed.value = false;
      }
    });

    return {
      helper,
      riskConfirmed,
    };
  },
});
</script>

<style scoped>
.alert-heading {
  font-size: 1rem;
}

.fraudex-comments {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

.fraudex-comments__title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 1rem;
}

.fraudex-comments__list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.fraudex-comments__item {
  padding: 1rem;
  margin-bottom: 0.75rem;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  font-size: 1rem;
  line-height: 1.5;
  color: #212529;
}

.fraudex-comments__item:last-child {
  margin-bottom: 0;
}
</style>
